import { forwardRef } from "react";
import FormControl from "@mui/material/FormControl";
import MuiInput from "@mui/material/Input";
import Tooltip from "@mui/material/Tooltip";
import type { InputProps } from "@mui/material/Input";
import ConditionCell from "./ConditionCell";
import InputCellInput from "./InputCellInput";
import ClockIcon from "../../icons/Clock";

type Props = {
  noTable?: boolean;
  pendingChange?: any;
  inputStyles?: any;
} & InputProps;

const InputCell = forwardRef(
  (
    {
      noTable = false,
      style,
      className,
      pendingChange,
      endAdornment,
      inputStyles = {},
      ...props
    }: Props,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    const Input = noTable ? MuiInput : InputCellInput;

    const control = (
      <FormControl style={{ width: "100%", height: "100%", display: "flex" }}>
        <Input
          disableUnderline
          inputRef={ref}
          className={pendingChange !== undefined ? "pendingChange" : undefined}
          endAdornment={
            <>
              {endAdornment}
              {pendingChange !== undefined ? (
                <Tooltip
                  arrow
                  title={`Pending specification change to ${pendingChange}`}
                >
                  <div className="pendingIconContainer">
                    <ClockIcon />
                  </div>
                </Tooltip>
              ) : null}
            </>
          }
          style={inputStyles}
          {...props}
        />
      </FormControl>
    );
    return noTable ? (
      <div style={style} className={className || ""}>
        {control}
      </div>
    ) : (
      <ConditionCell style={style} className={className || ""}>
        {control}
      </ConditionCell>
    );
  }
);

export default InputCell;
